(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('afp-cart-offers')) {
    customElements.define('afp-cart-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-config]').textContent);
        this.form = this.querySelector('form');
        this.panel = this.querySelector('.afp-cart-offers__panel');
        this.buy = this.querySelector('[data-buy]');
        this.govx = this.querySelector('[data-govx]');
        this.error = this.querySelector('[data-error]');
        this.ids = new Set(this.config.variants.map(v => String(v.id)));
        this.controller = new AbortController();
        this.form.addEventListener('submit', event => this.add(event), { signal: this.controller.signal });
        document.addEventListener('change', () => this.sync(), { signal: this.controller.signal });
        window.addEventListener('scroll', () => this.onScroll(), { passive: true, signal: this.controller.signal });
        this.resize = new ResizeObserver(() => {
          this.style.setProperty('--afp-panel-height', `${this.panel.getBoundingClientRect().height}px`);
        });
        this.resize.observe(this.panel);
        // Also catches theme scripts that update hidden variant inputs without a change event.
        this.timer = window.setInterval(() => { this.sync(); this.checkOverlays(); this.watchTrigger(); }, 750);
        this.mountInline();
        this.sync();
        this.checkOverlays();
        this.watchTrigger();
      }

      // Desktop: a second copy of the panel sits in the product info column, so the offer is visible on first open.
      // The pinned bar then only appears once that copy has scrolled off the top.
      mountInline() {
        if (this.dataset.inline !== 'true' || this.inlineWrap) return;
        const target = document.querySelector(this.dataset.inlineTarget || '.m-product-info--wrapper');
        if (!target || this.contains(target) || target.closest('afp-cart-offers')) return;
        const wrap = document.createElement('div');
        wrap.className = 'afp-cart-offers afp-cart-offers--inline';
        wrap.setAttribute('style', this.getAttribute('style') || '');
        const panel = this.panel.cloneNode(true);
        panel.classList.add('afp-cart-offers__panel--inline');
        const form = panel.querySelector('form');
        form.id = `${form.id}-inline`;
        form.addEventListener('submit', event => this.add(event), { signal: this.controller.signal });
        wrap.appendChild(panel);
        target.appendChild(wrap);
        this.inlineWrap = wrap;
      }

      // Reveal rule: the panel slides up as soon as the shopper scrolls past the set distance,
      // and stays down while the cookie banner is up (live site only; the editor keeps it visible for styling).
      updateVisibility() {
        const revealOff = this.dataset.reveal !== 'true';
        const show = (revealOff || this.scrolledPast === true) && !this.cookieBlocked;
        this.classList.toggle('afp-cart-offers--visible', show);
      }

      onScroll() {
        const inline = this.inlineWrap;
        if (inline && inline.offsetParent !== null) {
          this.scrolledPast = inline.getBoundingClientRect().bottom < 0;
        } else {
          this.scrolledPast = window.scrollY > Number(this.dataset.revealOffset || 0);
        }
        this.updateVisibility();
      }

      watchTrigger() {
        this.onScroll();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.inlineWrap?.remove();
        this.inlineWrap = null;
        this.resize?.disconnect();
        this.observer?.disconnect();
        window.clearInterval(this.timer);
        this.initialized = false;
      }

      sourceForm() {
        const candidates = Array.from(document.forms).filter(form => {
          if (this.contains(form) || form.closest('afp-cart-offers, .afp-cart-offers')) return false;
          return /\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname)
            && this.ids.has(String(new FormData(form).get('id')));
        });
        return candidates.find(form => form.getClientRects().length > 0) || candidates[0] || this.form;
      }

      sync() {
        if (this.busy) return;
        const source = this.sourceForm();
        const data = new FormData(source);
        const variant = this.config.variants.find(v => String(v.id) === String(data.get('id')));
        if (!variant) return;
        this.variant = variant;
        const selector = this.querySelector('[data-fallback-variant]');
        if (selector) selector.hidden = source !== this.form;
        const showOffer = this.config.sameCurrency && !data.get('selling_plan');
        const signature = `${variant.id}:${showOffer}`;
        if (signature === this.signature) return;
        this.signature = signature;
        this.buy.disabled = !variant.available;
        if (this.govx) this.govx.disabled = !variant.available;
        this.querySelector('[data-buy-label]').textContent = variant.available ? this.config.buttonLabel : this.config.soldOutLabel;
        const original = this.querySelector('[data-original]');
        original.textContent = variant.price;
        original.hidden = !showOffer || this.config.publicSaving <= 0;
        this.querySelector('[data-public-price]').textContent = showOffer ? variant.publicPrice : variant.price;
        const publicNote = this.querySelector('[data-public-note]');
        this.publicNoteHtml ||= publicNote.innerHTML.trim();
        if (showOffer) publicNote.innerHTML = this.publicNoteHtml; else publicNote.textContent = this.config.currencyNote;
        // Shipping line: product metafield wins, otherwise in-stock vs backorder text for this variant.
        const ship = this.querySelector('[data-ship-detail]');
        if (ship) ship.textContent = this.config.shipOverride || (variant.backorder ? this.config.shipBackorder : this.config.shipInStock);
        if (this.govx) {
          this.querySelector('[data-govx-saving]').hidden = !showOffer;
          this.querySelector('[data-govx-price-wrap]').hidden = !showOffer;
          this.querySelector('[data-govx-price]').textContent = variant.govxPrice;
        }
      }

      checkOverlays() {
        // Stay pinned, but sit above the cookie banner while it is showing. Unpin only for full-screen chat.
        const cookie = document.querySelector('#m-cookie-banner');
        const cookieVisible = cookie && cookie.getClientRects().length > 0
          && getComputedStyle(cookie).visibility !== 'hidden'
          && getComputedStyle(cookie).display !== 'none'
          && getComputedStyle(cookie).opacity !== '0'
          && cookie.getBoundingClientRect().top < window.innerHeight
          && cookie.getBoundingClientRect().bottom > 0;
        this.baseBottom ??= this.style.getPropertyValue('--afp-bottom') || '0px';
        if (this.dataset.design === 'true') {
          // Theme editor: the banner never goes away there, so sit above it.
          this.style.setProperty('--afp-bottom', cookieVisible ? `${Math.ceil(cookie.getBoundingClientRect().height)}px` : this.baseBottom);
        } else {
          // Live site: stay hidden until the shopper has dealt with the cookie banner.
          this.cookieBlocked = Boolean(cookieVisible);
        }
        this.updateVisibility();
        this.classList.toggle('afp-cart-offers--blocked', document.documentElement.classList.contains('missive-chat-fullscreen'));
      }

      async add(event) {
        event.preventDefault();
        if (this.busy) return;
        this.sync();
        if (!this.variant?.available) return;
        const form = (event.target.closest && event.target.closest('form')) || this.form;
        const panel = form.closest('.afp-cart-offers__panel') || this.panel;
        const q = selector => panel.querySelector(selector);
        if (!form.reportValidity()) return;
        const data = new FormData(form);
        if (!data.has('quantity')) data.set('quantity', '1');
        data.delete('sections');
        data.delete('sections_url');
        data.delete('return_to');
        this.busy = true;
        q('[data-error]').hidden = true;
        q('[data-cart-link]').hidden = true;
        panel.querySelectorAll('[data-buy], [data-govx]').forEach(button => { button.disabled = true; });
        form.setAttribute('aria-busy', 'true');
        q('[data-buy-label]').textContent = this.config.loadingLabel;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
          });
          const result = await response.json().catch(() => { throw new TypeError(this.config.errorLabel); });
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.config.errorLabel);
          // GovX verifies through the existing cart widget. This never issues a GovX discount.
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          q('[data-error]').textContent = error instanceof TypeError ? this.config.errorLabel : (error.message || this.config.errorLabel);
          q('[data-error]').hidden = false;
          q('[data-cart-link]').hidden = false;
          this.busy = false;
          form.removeAttribute('aria-busy');
          panel.querySelectorAll('[data-buy], [data-govx]').forEach(button => { button.disabled = !this.variant.available; });
          q('[data-buy-label]').textContent = this.config.buttonLabel;
          this.signature = null;
          this.sync();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
